import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Button, Divider, TextField, Typography } from '@mui/material';
import firebase from 'firebase/app';
import React, { useEffect, useState } from 'react';
import { DateToday } from '../../../constants/functions';
import { withFirebase } from '../../Firebase';
import BackButton from './BackButton';
import HostAutocomplete from './hostAutocomplete';
import HostFound from './hostFound';
import Loading from './loading';
import NextButton from './nextButton';

const VisitorMeeting = ({
   customisations,
   clearForm,
   goBack,
   locationName,
   visitorOptions,
   setStatus,
   status,
   host,
   setHost,
   form,
   lid,
   confirmed,
   setConfirmed,
   contractor,
   selectedContractor,
   ...props
}) => {
   const [loading, setLoading] = useState(true);

   const [name, setName] = useState('');
   const [nameError, setNameError] = useState({ status: false, text: '' });
   const [nameList, setNameList] = useState(false);
   const [checkedIn, setCheckedIn] = useState(false);
   const [multiOptions, setMultiOptions] = useState(false);
   const [unannouncedVisitor, setUnannouncedVisitor] = useState(false);
   const [checkoutData, setCheckoutData] = useState({});
   const [confirmationStatementCheckbox, setConfirmationStatementCheckbox] =
      useState(false);

   useEffect(() => {
      let isMounted = true;

      const checkHost = async () => {
         if (!form) return;

         let cleanEmail = form.email.toLowerCase();
         let found = await props.firebase
            .findHost(lid, DateToday().ref)
            .get()
            .then((result) => {
               if (result.exists && cleanEmail in result.data()) {
                  return result.data()[cleanEmail];
               } else {
                  return false;
               }
            });

         if (contractor && customisations.contractorHostEmail && isMounted) {
            setHost({
               found: true,
               name: customisations?.contractorHostEmail.name,
               email: customisations?.contractorHostEmail.email,
            });
            setUnannouncedVisitor(true);
         }

         if (found && isMounted) {
            setUnannouncedVisitor(false);
            if (found.checkout) {
               setHost({
                  ...host,
                  found: true,
                  name: found.host.name,
                  email: found.host.email,
                  checkin: found.checkin,
                  checkout: found.checkout,
               });
            } else {
               setHost({
                  found: true,
                  name: found.host.name,
                  email: found.host.email,
               });
            }

            if (
               (!found.checkin || (found.checkin && found.checkout)) &&
               customisations?.carReg &&
               form.carReg == undefined
            ) {
               setStatus('carReg');
            } else if (
               (!found.checkin || (found.checkin && found.checkout)) &&
               customisations?.contactNumber &&
               form.contactNumber == undefined
            ) {
               setStatus('contactNumber');
            } else if (
               (!found.checkin || (found.checkin && found.checkout)) &&
               customisations?.visitorPass &&
               form.visitorPass == undefined
            ) {
               setStatus('visitorPass');
            }

            if (found.checkin && !found.checkout) {
               setCheckoutData({
                  visitorEmail: found.email,
                  visitorName: found.name,
                  hostName: found.host.name,
                  hostEmail: found.host.email,
                  locationName: locationName,
                  checkedIn: true,
                  host: true,
               });
               setCheckedIn(true);
            }
         } else if (isMounted) {
            if (customisations?.carReg && form?.carReg == undefined) {
               setStatus('carReg');
            } else if (
               customisations?.contactNumber &&
               form?.contactNumber == undefined
            ) {
               setStatus('contactNumber');
            } else if (
               customisations?.visitorPass &&
               form?.visitorPass == undefined
            ) {
               setStatus('visitorPass');
            } else if (!contractor) {
               let employees = await props.firebase.allHosts(lid).get();
               setNameList(employees.data());
               setHost({ found: false, name: '', email: '' });
               setUnannouncedVisitor(true);
            }
         }

         if (isMounted) setLoading(false);
      };

      checkHost();

      return () => {
         isMounted = false;
      };
   }, [form]);

   function handleSubmit() {
      if (name === '') {
         setNameError({ status: true, text: 'You must enter a host name or email' });
      } else {
         let foundNames = {};
         Object.entries(nameList).map(([key, value]) => {
            if (
               value.toLowerCase() == name.toLowerCase() ||
               key.toLowerCase() == name.toLowerCase()
            ) {
               foundNames[key] = value;
            }
         });
         if (Object.keys(foundNames).length === 1) {
            setHost({
               found: true,
               name: Object.values(foundNames)[0],
               email: Object.keys(foundNames)[0],
            });
         } else if (Object.keys(foundNames).length > 1) {
            setMultiOptions(foundNames);
            setNameError({ status: false, text: '' });
         } else {
            setNameError({
               status: true,
               text: "Oops, we can't find these details in our host list. Please call your host if you are struggling to register.",
            });
         }
      }
   }

   async function alertHost() {
      setLoading(true);
      var email = firebase.functions().httpsCallable('sendgridVisitors-sendgridVisitors');
      let data = {
         checkedIn: false,
         host: true,
         visitorName: form.name,
         visitorEmail: form.email,
         hostName: host.name,
         hostEmail: host.email,
         locationName,
         carReg: form.carReg || false,
         contactNumber: form.contactNumber || false,
      };
      try {
         await props.firebase.visitorCheckin(
            form,
            lid,
            DateToday().ref,
            'checkin',
            unannouncedVisitor,
            host,
            selectedContractor,
         );
         await email(data);
         data.host = false;
         await email(data);
      } catch (error) {
         console.warn(error, 'error');
      }
      setLoading(false);
      setStatus('step3');
   }

   async function checkout() {
      setLoading(true);
      try {
         await props.firebase.visitorCheckin(form, lid, DateToday().ref, 'checkout');
         var email = firebase
            .functions()
            .httpsCallable('sendgridVisitors-sendgridVisitors');
         await email(checkoutData);
      } catch (error) {
         console.warn(error, 'error');
      }
      setLoading(false);
      setStatus('step3');
   }

   return (
      <>
         {loading ? (
            <Loading />
         ) : (
            <Box
               sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 3,
                  mb: 3,
                  justifyContent: 'space-between',
                  width: '100%',
               }}
            >
               {!checkedIn && <BackButton goBack={goBack} />}
               <Box sx={{ minWidth: checkedIn ? '85%' : '70%', flexDirection: 'column' }}>
                  {checkedIn ? (
                     <>
                        <Typography variant="h5" component="h2">
                           Leaving?
                        </Typography>
                        <Typography variant="h6" component="h3">
                           Thank you for visiting
                        </Typography>
                        <Typography variant="body1" component="p">
                           Please click on Check Out below to complete your visit.
                        </Typography>
                     </>
                  ) : host.found ? (
                     <HostFound
                        host={host}
                        setHost={setHost}
                        setStatus={setStatus}
                        clearForm={clearForm}
                        customisations={customisations}
                        form={form}
                        lid={lid}
                        setLoading={setLoading}
                        unannouncedVisitor={unannouncedVisitor}
                        locationName={locationName}
                        confirmed={confirmed}
                        setConfirmed={setConfirmed}
                        confirmationStatementCheckbox={confirmationStatementCheckbox}
                        setConfirmationStatementCheckbox={
                           setConfirmationStatementCheckbox
                        }
                     />
                  ) : (
                     <>
                        <Typography variant="body1" component="p">
                           Please enter the name or email address of your host below.
                        </Typography>
                        {visitorOptions !== null &&
                        visitorOptions.visitorHostAutocomplete &&
                        nameList ? (
                           <HostAutocomplete
                              nameList={nameList}
                              setName={setName}
                              name={name}
                              nameError={nameError}
                           />
                        ) : nameList ? (
                           <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="name"
                              label="Name / Email"
                              name="name"
                              value={name}
                              onInput={(e) => {
                                 setName(e.target.value);
                              }}
                              error={nameError.status}
                              helperText={nameError.text}
                           />
                        ) : (
                           <Loading />
                        )}

                        {multiOptions && (
                           <React.Fragment>
                              <Typography variant="body1" component="p">
                                 We found multiple people with that name, please click on
                                 your correct host's name.
                              </Typography>
                              {Object.entries(multiOptions).map(([key, value]) => (
                                 <div
                                    onClick={() => {
                                       setHost({ found: true, name: value, email: key });
                                    }}
                                    style={{
                                       marginTop: 2,
                                       padding: 2,
                                       border: '1px solid #342E76',
                                       borderRadius: 8,
                                       cursor: 'pointer',
                                       '&:hover': {
                                          backgroundColor: '#342E76',
                                          color: 'white',
                                       },
                                    }}
                                    key={key}
                                 >
                                    <Typography variant="body1" align="center">
                                       {value}
                                    </Typography>
                                    <Typography variant="caption" align="center">
                                       {key}{' '}
                                    </Typography>
                                 </div>
                              ))}
                           </React.Fragment>
                        )}
                     </>
                  )}
               </Box>

               <NextButton
                  checkedIn={checkedIn}
                  handleSubmit={handleSubmit}
                  host={host}
                  checkout={checkout}
                  alertHost={alertHost}
                  customisations={customisations}
                  setConfirmed={setConfirmed}
                  confirmed={confirmed}
                  confirmationStatementCheckbox={confirmationStatementCheckbox}
               />
            </Box>
         )}
         <Divider sx={{ width: '100%' }} />
         {!loading && (
            <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center' }}>
               <Button startIcon={<ReplayIcon />} onClick={clearForm}>
                  start again
               </Button>
            </Box>
         )}
      </>
   );
};
export default withFirebase(VisitorMeeting);
